var map = {
	"./404.svg": "5543",
	"./bug.svg": "f55c",
	"./chart.svg": "6683",
	"./clipboard.svg": "f5e0",
	"./component.svg": "1c60",
	"./dashboard.svg": "dc9e",
	"./documentation.svg": "f8bc",
	"./down.svg": "ef39",
	"./drag.svg": "a621",
	"./edit.svg": "ee63",
	"./email.svg": "1d76",
	"./example.svg": "1699",
	"./excel.svg": "c5a3",
	"./exit-fullscreen.svg": "1685",
	"./eye-open.svg": "69ec",
	"./eye.svg": "4473",
	"./form.svg": "b539",
	"./fullscreen.svg": "06d5",
	"./guide 2.svg": "7494",
	"./guide.svg": "4301",
	"./hongchong.svg": "8d60",
	"./icon-PDF.svg": "bbbd",
	"./icon-excel.svg": "17ac",
	"./icon-jpg.svg": "7ab9",
	"./icon-txt.svg": "cec7",
	"./icon-unknown.svg": "262b",
	"./icon-word.svg": "b562",
	"./icon-zip.svg": "1deb",
	"./icon.svg": "e6d0",
	"./international.svg": "4809",
	"./language.svg": "090e",
	"./link.svg": "0982",
	"./list.svg": "75de",
	"./lock.svg": "c34e",
	"./logo.svg": "088a",
	"./message.svg": "ea37",
	"./money.svg": "5a2d",
	"./nested.svg": "6def",
	"./opinovice.svg": "7475",
	"./password.svg": "fa91",
	"./pdf.svg": "9501",
	"./people.svg": "6e4d",
	"./peoples.svg": "f6b8",
	"./qq.svg": "7fc8",
	"./search.svg": "04e6",
	"./setup.svg": "7614",
	"./shopping.svg": "595f",
	"./size.svg": "5960",
	"./star.svg": "6bd1",
	"./tab.svg": "7ff5",
	"./table.svg": "0154",
	"./theme.svg": "952b",
	"./tree.svg": "ff96",
	"./user.svg": "d5d9",
	"./wechat.svg": "c704",
	"./zip.svg": "e57e",
	"./zuofei.svg": "03e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16aa";